export const ROUTES = {
    home: '/',
    overview: '/overview',
    maintenance: '/maintenance',
    paymentLinks: '/payments/payment-links',
    payments: '/payments',
    onlinePayments: '/payments/online-payments',
    chargebacks: '/chargebacks',
    posPayments: '/payments/pos-payments',
    posAmexPayments: '/payments/pos-amex-payments',
    settlements: {
        base: '/settlements',
        perSettlementDate: '/settlements/per-settlement-date',
        perTransactionDate: '/settlements/per-transaction-date'
    },
    dcc: '/dcc',
    zashEpos: '/zash-epos',
    referAFriend: '/refer-a-friend',
    digitalReceipts: '/digital-receipts',
    billing: {
        base: '/billing',
        invoices: '/billing/invoices'
    },
    virtualTerminal: '/payments/virtual-terminal',
    reports: '/reports',
    exports: '/exports',
    profile: '/profile',
    // paymentMethods: '/payment-methods',
    // paymentMethodDetails: '/payment-methods/detail/:type',
    businessAccount: {
        accountInfo: '/business-account/account-info',
        cardsManagement: '/business-account/cards-management',
        makeTransfer: '/business-account/transfer'
    },
    settings: {
        base: '/settings',
        developers: '/settings/developers',
        checkout: '/settings/checkout',
        tariffs: '/settings/tariffs',
        companyProfile: '/settings/company-profile',
        bankAccounts: '/settings/bank-accounts',
        bankAccountCreate: '/settings/bank-account-create',
        changeBankAccountDetails: 'change-bank-account-details',
        posOutlets: '/settings/pos-outlets',
        onlineOutlets: '/settings/online-outlets',
        paymentMethods: '/settings/payment-methods',
        paymentMethodDetails: '/settings/payment-methods/detail/:type',
        teamManagement: '/settings/team-management'
    },
    // teamManagement: '/team-management',
    login: '/login',
    resetPassword: '/reset-password',
    twoFA: '/two-factor-authentication',
    recoveryCode: '/recovery-code',
    chooseCompany: '/choose-company',
    resetPasswordFailure: '/reset-password-failure',
    signUp: {
        base: '/sign-up',
        setPassword: '/sign-up/set-password',
        success: '/sign-up/success',
        confirm: '/sign-up/confirm-signup'
    },
    confirmEmail: '/confirm-email',
    confirmTwoFA: '/confirm-2fa',
    twoFAEnforced: '/enforce-2fa',
    setPassword: '/set-password',
    setPasswordSuccess: '/set-password-success',
    signUpValidateRefCode: '/signup',
    signUpValidateEmail: '/signup-validate-email',
    signUpValidateOtpCode: '/signup-validate-otp',
    signUpCreatePassword: '/signup-create-password',
    noPermissions: '/no-permissions',
    ecospendReturn: '/ecospend-return',
    noPage: '/no-page',
    onboarding: {
        base: '/onboarding',
        companyDetails: '/onboarding/company-details',
        companyContacts: '/onboarding/company-contacts',
        ownersDirectors: '/onboarding/owners-directors',
        ownerCreate: '/onboarding/owners-directors/owner',
        corporateOwnerCreate: '/onboarding/owners-directors/corporate-owner',
        directorCreate: '/onboarding/owners-directors/director',
        bankDetails: '/onboarding/bank-details',
        bankAccountCreate: '/onboarding/bank-details/create',
        documents: '/onboarding/documents',
        outletsInformation: '/onboarding/outlets-information',
        outletCreate: '/onboarding/outlets-information/outlet',
        reviewSubmit: '/onboarding/review-submit',
        applicationProgress: '/onboarding/application-progress',
        selfOnboardingStatus: '/onboarding/self-onboarding-status'
    }
}
